/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculate the melting temperature of a DNA oligo or PCR primer. The headline value uses the nearest-neighbor method (SantaLucia 1998) with salt correction; the basic Wallace rule and GC% estimate are shown for comparison.`)
};

const es_tm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcula la temperatura de fusión de un oligo de ADN o cebador de PCR. El valor principal usa el método de vecino más cercano (SantaLucia 1998) con corrección de sal; se muestran también la regla básica de Wallace y la estimación por %GC para comparar.`)
};

const de_tm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berechnen Sie die Schmelztemperatur eines DNA-Oligos oder PCR-Primers. Der Hauptwert verwendet die Nearest-Neighbor-Methode (SantaLucia 1998) mit Salzkorrektur; die einfache Wallace-Regel und die GC%-Schätzung werden zum Vergleich angezeigt.`)
};

const nl_tm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereken de smelttemperatuur van een DNA-oligo of PCR-primer. De hoofdwaarde gebruikt de nearest-neighbor-methode (SantaLucia 1998) met zoutcorrectie; de eenvoudige Wallace-regel en GC%-schatting worden ter vergelijking getoond.`)
};

const fr_tm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculez la température de fusion d'un oligo d'ADN ou d'une amorce PCR. La valeur principale utilise la méthode des plus proches voisins (SantaLucia 1998) avec correction de sel ; la règle de Wallace de base et l'estimation par %GC sont affichées à titre de comparaison.`)
};

const it_tm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcola la temperatura di fusione di un oligo di DNA o di un primer per PCR. Il valore principale usa il metodo dei vicini più prossimi (SantaLucia 1998) con correzione salina; la regola di Wallace di base e la stima GC% sono mostrate per confronto.`)
};

const pt_br2_tm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a temperatura de fusão de um oligo de DNA ou primer de PCR. O valor principal usa o método do vizinho mais próximo (SantaLucia 1998) com correção de sal; a regra básica de Wallace e a estimativa por GC% são mostradas para comparação.`)
};

const pt_tm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcule a temperatura de fusão de um oligonucleótido de ADN ou primer de PCR. O valor principal usa o método do vizinho mais próximo (SantaLucia 1998) com correção salina; a regra básica de Wallace e a estimativa por GC% são mostradas para comparação.`)
};

const ja_tm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`DNAオリゴまたはPCRプライマーの融解温度を計算します。主な値は最近接塩基対法 (SantaLucia 1998) と塩濃度補正を使用し、比較のために基本的なWallace法とGC%推定値も表示されます。`)
};

const zh_tm_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算 DNA 寡核苷酸或 PCR 引物的解链温度。主要结果使用最近邻法（SantaLucia 1998）并结合盐浓度校正；同时显示基本的 Wallace 规则和 GC% 估算值以供比较。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_intro", locale)
	if (locale === "en") return en_tm_intro(inputs)
	if (locale === "es") return es_tm_intro(inputs)
	if (locale === "de") return de_tm_intro(inputs)
	if (locale === "nl") return nl_tm_intro(inputs)
	if (locale === "fr") return fr_tm_intro(inputs)
	if (locale === "it") return it_tm_intro(inputs)
	if (locale === "pt-BR") return pt_br2_tm_intro(inputs)
	if (locale === "pt") return pt_tm_intro(inputs)
	if (locale === "ja") return ja_tm_intro(inputs)
	return zh_tm_intro(inputs)
};